import * as stylex from '@stylexjs/stylex'
import { type ElementType, type PropsWithChildren } from 'react'
import { Box, type BoxProps } from '../Box/Box'

const baseStyles = stylex.create({
  root: {
    padding: '0 16px 16px 16px',
    flex: '1 1 auto',
    boxSizing: 'border-box',
    overflowY: 'auto',
  },
})

/**
 * DialogContent 的屬性，繼承自 BoxProps。
 */
export type DialogContentProps<RootComponent extends ElementType = 'div', BoxElement extends HTMLElement = HTMLDivElement> = BoxProps<RootComponent, BoxElement>

/**
 * DialogContent 對話框內容區域元件。
 * 提供內建的 padding 與垂直捲動功能。
 */
export const DialogContent = <RootComponent extends ElementType = 'div', BoxElement extends HTMLElement = HTMLDivElement>(props: PropsWithChildren<DialogContentProps<RootComponent, BoxElement>>) => {
  const { component = 'div', rootStyle, ...rest } = props

  return (
    <Box component={component} rootStyle={[baseStyles.root, rootStyle]} {...rest} />
  )
}
